module.exports = __webpack_public_path__ + "static/img/1_1_3_3.1c3690b0.jpg";